import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { Country, CountryRegion } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class LocationsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCountries(): Observable<Country[]> {
    return this.httpApi.get(`/countries`).pipe(map(data => data.countries));
  }

  public fetchRegions(countryCode: string): Observable<CountryRegion[]> {
    return this.httpApi
      .get(`/regions`, { country_code: countryCode })
      .pipe(map(data => data.regions));
  }
}
